import React from "react";
import "./MobileContributionTable.css";
import Counties from "../../../config/CountiesConfig";
import {BurnModelUtils} from "../../../utils/burnModelUtils";
import {FileUtils} from "../../../utils/fileUtils";
import AppConfig from "../../../config/AppConfig";


export class MobileContributionTable extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            countyContributionToday: Counties,
            countyContributionTomorrow: Counties
        }
    }

    async componentDidMount(){
        try {
            const [day0Csv, day1Csv] = await Promise.all([
                FileUtils.getContributionFileToday(this.props.cst),
                FileUtils.getContributionFileTomorrow(this.props.cst),
            ]);

            this.setState({
                countyContributionToday:
                    BurnModelUtils.getCountyContributions(day0Csv),
                countyContributionTomorrow:
                    BurnModelUtils.getCountyContributions(day1Csv)
            });


        } catch (err) {
            console.error("Failed to load contribution CSVs", err);
            this.setState({ loading: false });
        }
    }

    _renderMobileContributionTable(county, formattedDate){

        if(!county)
            return

        return(

            <table className="mobile-contribution-table" cellPadding="0" cellSpacing="0">
                <thead className="mobile-contribution-table-head">
                <tr>
                    <th>{formattedDate}</th>
                </tr>

                </thead>

                <tbody className="mobile-contribution-table-body">
                    <tr key={county.id}>
                        <td
                            className={"contribution-table-inner-td-result"}
                            style={{backgroundColor:[county.backgroundColor]}}
                            onClick={() => window.location.href = `/view/details/?county=${county.name}`}
                        >
                            {county.contributionCategory || this.props.i18n.Contribution_Table_Unavailable}
                        </td>
                    </tr>
                </tbody>
            </table>
        )
    }

    render() {
        return (
            <div>
                    {
                        this._renderMobileContributionTable(
                            this.state.countyContributionToday.find(county => county.id === this.props.county.id),
                            this.props.cst.format(AppConfig.time.displayDateFormat)
                        )
                    }
                    {
                        this._renderMobileContributionTable(
                            this.state.countyContributionTomorrow.find(county => county.id === this.props.county.id),
                            this.props.cst.clone().add(1, "day").format(AppConfig.time.displayDateFormat)
                        )
                    }
            </div>
        );
    }
}
